


























import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import Mutations from '@/store/mutations';

@Component
export default class ReferenceGeneratorModal extends Vue
{
    pageNumber = '';
    selectedCategory = -1;
    selectedBook = -1;

    get categorySelect() {
        return [{text: 'Select a category', value: -1}, ...this.macMillanBooks.map((book, idx) => { return { text: book.category, value: idx }} )];
    }

    get isCategorySelected() { return this.selectedCategory !== -1; }

    get bookSelect() {
        return [{text: 'Select a book', value: -1}, ...this.macMillanBooks[this.selectedCategory].books.map((book, idx) => { return { text: book, value: idx }} )];
    }

    get isReadyToGenerate() {
        return this.selectedBook !== -1 && this.selectedCategory !== -1; // && this.pageNumber.trim() !== '';
    }

    randomInRange(min: number, max: number) {
        return Math.round(Math.random() % (max - min + 1)) + min;
    }

    get generatedCitation() {
        const publishYear = this.randomInRange(1970, 2021);
        let bookName = this.macMillanBooks[this.selectedCategory].books[this.selectedBook].trim();
        
        if (bookName.endsWith('.')) bookName = bookName.substring(0, bookName.length - 1);
        let intermediate = `AuthorLast, AuthorFirst. ${bookName}. MacMillan Learning, ${publishYear}`;
        
        const pageTrimmed = this.pageNumber.trim();
        if (pageTrimmed.length === 0) {
            intermediate += '.';
        } else {
            intermediate += `, p. ${pageTrimmed}`;
        }
        return intermediate;
    }

    macMillanBooks = [
        {
            category: 'Bedford Document Collections',
            books: ['European', 'U.S.', 'World']
        },
        {
            category: 'Bedford Tutorials for History',
            books: ['European', 'U.S.', 'World']
        },
        {
            category: 'European History',
            books: [
                '20th Century',
                'Ancient',
                'Atlantic World',
                'British',
                'Early Modern & Renaissance',
                'Enlightenment & Age of Reason',
                'European Intellectual',
                'French',
                'German',
                'Industrial Revolution & 20th Century',
                'Italian',
                'Medieval',
                'Western Civilization'
            ]
        },
        {
            category: 'The Bedford Series in History & Culture',
            books: [
                'European',
                'U.S.',
                'World',
            ]
        },
        {
            category: 'U.S. History',
            books: [
                'African American History',
                'By Period',
                'By Topic',
                'Native American History',
                'Reform & Labor History',
                'U.S. History Survey',
                'U.S. Women\'s History'
            ]
        },
        {
            category: 'World History',
            books: [
                'African History',
                'Ancient',
                'Asian History',
                'Atlantic World',
                'Early Modern',
                'Modern',
                'World History Survey'
            ]
        },
    ];
}
